import { NgModule } from "@angular/core";
import { UiDropdownMenuComponent } from "./components/dropdown-menu/dropdown-menu.component";
import { UiDropDownADirective } from "./directives/dropdown-a.directive";
import { UiDropdownButtonDirective } from "./directives/dropdown-button.directive";
import { UiDropDownDirective } from "./dropdown.directive";

@NgModule({
  imports: [UiDropDownDirective, UiDropDownADirective, UiDropdownMenuComponent, UiDropdownButtonDirective],
  exports: [UiDropDownDirective, UiDropDownADirective, UiDropdownMenuComponent, UiDropdownButtonDirective],
})
export class UiDropdownModule {}
